import "./Score.scss";
import { Game } from "../../Interfaces/bucket/Game";
import { useEffect, useState } from "react";
import { User } from "../../Interfaces/bucket/User";
import { GameResult } from "../../Interfaces/bucket/GameResult";
import { useSelector } from "react-redux";
import { RootState } from "../../App/store";
import DataTable from "../../components/shared/DataTable/DataTable";
import DataService from "../../Services/DataService";
import BackWebsite from "../../components/shared/BackWebsite/BackWebsite";

export interface ScoreProps {
  game?: Game;
}

export const Score = ({ game = {} }: ScoreProps) => {
  const [winner, setWinner] = useState<User>();
  const [scoreTable, setScoreTable] = useState<any>();

  const headers = [
    { title: "Rank", field: "rank" },
    { title: "Nickname", field: "nick_name" },
    { title: "Kills", field: "kill" },
    { title: "Damage Done", field: "damage" },
    { title: "Tokens Earned", field: "tokens_earned" },
    { title: "EXP Gained", field: "exp_gained" },
  ];

  const gameSelector = useSelector((state: RootState) => state.game);
  const handleBackLobby = () => {
    window.location.reload();
  };

  useEffect(() => {
    if (game && game.status == "ENDED") {
      setWinner(
        gameSelector.game_players.find((item) => item._id == game?.winner) || {
          nick_name: "",
        }
      );
    }
  }, [game]);

  const createScoreTable = async () => {
    const [gameResult] = (await DataService.resources.GameResult.getAll({
      queryParams: { filter: { game: gameSelector.game?._id } },
    }).catch(console.error)) as GameResult[];

    let scores = gameResult.players.map((item, index) => {
      return {
        ...item,
        nick_name: gameSelector.game_players.find(
          (player) => player._id == item.player_id
        )?.nick_name as string,
        _id: index,
      };
    });

    console.log("scores :", scores);

    setScoreTable(scores);
  };

  useEffect(() => {
    if (winner && !scoreTable) {
      createScoreTable();
    }
  }, [winner]);

  return (
    <div className="Score">
      <div className="Layout">
        <div className="Header">
          <img src="/assets/game/DashboardSnail.png" alt="" />
        </div>
        <div className="WinnerName">{winner?.nick_name} WON!</div>
        <h5 className="GameId">Game ID : {game._id}</h5>
        <DataTable headers={headers} data={scoreTable} />
        <div className="Footer">
          <div>
            Are you <span>Ready</span> for another battle?
          </div>
          <button onClick={handleBackLobby}>Next Battle</button>
        
        </div>
      </div>
      <BackWebsite></BackWebsite>
    </div>
  );
};
export default Score;
